<template>


  <v-form class="habeo-border mx-sm-16" :disabled="isLoading">

    <v-row>

      <!-- pickup date -->
      <v-col class="st" cols="12" sm="4">
        <v-datetime-picker :label="$t('main.availability_form.pickup_date_label')" v-model="avail.startTime">
          <v-icon slot="dateIcon">mdi-calendar-range</v-icon>
          <v-icon slot="timeIcon">mdi-clock-time-nine-outline</v-icon>
        </v-datetime-picker>
      </v-col>

      <!-- dropoff date -->
      <v-col cols="12" sm="4">
        <div style="display:block;">
          <v-datetime-picker :label="$t('main.availability_form.dropoff_date_label')" v-model="avail.endTime">
            <v-icon slot="dateIcon">mdi-calendar-range</v-icon>
            <v-icon slot="timeIcon">mdi-clock-time-nine-outline</v-icon>
          </v-datetime-picker>
        </div>
      </v-col>


      <v-col cols="12" sm="4">
        <div style="display:block;">
          <v-select v-model="avail.carCategories" :items="carCategoriesFromServer" :label="$t('main.availability_form.carCategories')"
                    multiple item-value="id" item-text="designation"></v-select>
        </div>
      </v-col>

    </v-row>

    <v-row>

      <v-col cols="12" sm="6" v-if="!googleLocationEnabled()">
        <vuetify-google-autocomplete
                id="map"
                append-icon=""
                v-bind:disabled="false"
                v-model="avail.localisation.address"
                placeholder="..."
                v-on:placechanged="getAddressData"
                :label="$t('booking.available_cars.localisation_label')"
        >
        </vuetify-google-autocomplete>
      </v-col>

      <!-- age check -->
      <v-col cols="12" sm="6">
        <v-switch v-model="avail.age" :label="$t('main.availability_form.age_between_label')" color="indigo"
                  inset></v-switch>
      </v-col>

    </v-row>

    <!-- submit button -->
    <v-row>
      <v-col cols="12" sm="12" align="center">
        <v-btn @click="findAvailCars()" size="is-medium" color="indigo" depressed outlined
               :disabled="isSearchButtonDisabled" :loading="isLoading">
          <v-icon class="mr-2">mdi-feature-search</v-icon>
          {{ $t('main.availability_form.find_cars_btn_label') }}
        </v-btn>
      </v-col>
    </v-row>


    <AppAlert :alert="error"/>


  </v-form>


</template>


<script>


  import moment from 'moment'
  import { Alert } from '../models'
  import { CarCategoriesApi } from '../services/api/car-categories'

  export default {
    name: 'AvailabilityForm',
    data () {
      return {
        avail: this.$store.getters['booking/avail'] || INIT_AVAIL,
        isLoading: false,
        error: null,
        carCategoriesFromServer: []
      }
    },
    methods: {
      findAvailCars () {
        console.log('findAvailCars obj', this.avail);
        if (!moment(this.avail.startTime).isBefore(this.avail.endTime)) {
          this.error = new Alert({
            message: this.$i18n.t('main.availability_form.pickup_before_dropoff'),
            color: 'orange'
          });
        } else {
          this.error = null;
          this.isLoading = true;
          this.$store.dispatch('booking/initContext', this.avail)
            .then(() => this.processTheSearch())
            .catch(error => this.error = error)
            .finally(() => this.isLoading = false);
        }
      },
      getAddressData: function (addressData, placeResultData, id) {
        console.debug('set adress Form', addressData, placeResultData, id);
        this.avail.localisation = {
          longitude: addressData.longitude,
          latitude: addressData.latitude,
          address: placeResultData.formatted_address
        }
      },
      processTheSearch: function () {
        console.log('processTheSearch', this.avail,JSON.stringify(this.avail));
        let searchRequest = { data: encodeURIComponent(JSON.stringify(this.avail)) };
        if (this.$route.name === 'available-cars') {
          this.$router.replace({ query: searchRequest })
        } else {
          this.$router.push({ name: 'available-cars', query: searchRequest });
        }
      },
      googleLocationEnabled: function () {
        // Disable localisation field
        var disableLocationFieldFor = ["stbarthrental", "localhost","carloc"]
        for (const href of disableLocationFieldFor) {
          if (window.location.href.includes(href)) {
            return true;
          }
        }
        return false;
      }
    },
    computed: {
      isSearchButtonDisabled () {
        return this.avail.startTime == null || this.avail.endTime == null || this.avail.localisation == null || !this.avail.age;
      }
    },
    mounted: function () {
      console.debug(' Initial availablity info ', this.avail);
      CarCategoriesApi.getAll()
        .then((data) => {
          this.carCategoriesFromServer = data;
        })
        .catch(error => console.error(error))
        .finally();

    }
  }
</script>
